import { render } from "./ConfigDrawer.vue?vue&type=template&id=3d958484&scoped=true"
import script from "./ConfigDrawer.vue?vue&type=script&lang=js"
export * from "./ConfigDrawer.vue?vue&type=script&lang=js"

import "./ConfigDrawer.vue?vue&type=style&index=0&id=3d958484&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d958484"]])

export default __exports__